import { useTranslation } from 'react-i18next'

import { EMPTY_FUNCTION } from '../../../constants/common'
import Button, { BUTTON_HEIGHT_24 } from '../../Button'

/**
 * @typedef {object} SearchTypeButtonProps
 *
 * @property {number} [height]
 *
 * @property {boolean} [selected]
 *
 * @property {SearchType} value
 *
 * @property {(value: SearchType) => void} [onSelect]
 */

/**
 * @param {SearchTypeButtonProps} props
 */
function SearchTypeButton({
  height = BUTTON_HEIGHT_24,
  selected = false,
  value,
  onSelect = EMPTY_FUNCTION,
}) {
  const { title, tooltip } = value

  const { t } = useTranslation()

  function handleClick() {
    onSelect(value)
  }

  return (
    <Button.Contained
      height={height}
      isGrey={!selected}
      isLight={selected}
      text={t(title)}
      tooltip={t(tooltip)}
      onClick={handleClick}
    />
  )
}

export default SearchTypeButton
